import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NavigationStart, Router, Event } from '@angular/router';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, take } from 'rxjs/operators';
import { CUMULATIVE_BOX_CONTROL, CUMULATIVE_BOX_STORE } from '../editing-box-overlay.config';
import { EditingBoxStreamService } from '../editing-box-stream.service';
import { CumulativeBoxStore } from './cumulative-box.service';

@UntilDestroy()
@Component({
  selector: 'miq-cumulative-box',
  templateUrl: './cumulative-box.component.html',
  styleUrls: ['./cumulative-box.component.scss'],
  standalone: false,
})
export class CumulativeBoxComponent implements OnInit, OnDestroy {
  public showAutoSumCtrl = true;
  public enableAutoSumCtrl: UntypedFormControl;
  public valid = true;

  get templateInput() {
    return this.store.getCustomTemplateRefMap();
  }

  constructor(
    @Inject(CUMULATIVE_BOX_CONTROL) private overlayControl: { close: (data) => void },
    @Inject(CUMULATIVE_BOX_STORE) public store: CumulativeBoxStore,
    private router: Router,
    private streamService: EditingBoxStreamService
  ) {}

  ngOnInit() {
    this.showAutoSumCtrl = this.store.showAutoSumControl;
    this.enableAutoSumCtrl = new UntypedFormControl(this.store.getAutoSumStateSnap());
    this.enableAutoSumCtrl.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe(autoSumEnabled => this.store.setAutoSumState(autoSumEnabled));
    // dispose on navigation start
    this.router.events
      .pipe(
        filter((event: Event) => event instanceof NavigationStart),
        take(1)
      )
      .subscribe(() => this.overlayControl.close(null));
    // run eager validation to early detect problems and disable the 'done' button
    this.validate();
  }

  ngOnDestroy() {
    // required by untilDestroyed
  }

  closeBox() {
    if (this.valid) {
      this.overlayControl.close(this.store);
    }
  }

  validate() {
    this.valid = this.store.validateAndUpdateTotalColumn();
  }

  change({ column, field, value }) {
    if (column && column.parent && column.parent.update) {
      const {
        entity: { id: recordId },
      } = this.store.record;
      this.streamService.pushChangeStream({
        recordId,
        column,
        field,
        value,
      });
    }
  }
}
